module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "part2"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page29"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007toc#p02"
    }
  }, [_vm._v("PART 2"), _c('br'), _vm._v("Religion Is A Headache")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Many Christians still walk in Old Covenant bondage."), _c('br'), _vm._v("Regarding the law as a Divine ordinance for our direction,"), _c('br'), _vm._v("they consider themselves prepared and fitted by conversion to"), _c('br'), _vm._v("take up the fulfillment of the law as a natural duty.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Andrew Murray (1828-1917)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cac09ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/013part2.vue
// module id = 90
// module chunks = 0